module.exports = __webpack_public_path__ + "img/user.54a04098.svg";